const config = {
	BASE_URL: "http://keyplan.ykkapyesadmin.com/api",
};

export default config;
